import { Formik } from 'formik';
import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { SaveButton } from 'src/libs/ui-kit/buttons/SaveButton';
import { useStore } from 'src/modules/users/hooks/useStore';
import { IUserAddressForm } from '../../service-provider/interface';
import { UserAddressesStoreContext } from '../../UserAddresses.widget';
import { UserAddressEditForm } from '../forms/UserAddressEditForm';

export const UserAddressEditModal: FC = observer(() => {
  const initialAddress: IUserAddressForm = {
    type: null,
    value: null,
  };

  const store = useStore(UserAddressesStoreContext);

  return (
    <Formik
      initialValues={store.chosenAddress || initialAddress}
      validateOnMount
      onSubmit={store.updateAddress}
      enableReinitialize>
      <Modal className="modal-slide" show={store.editAddressModal.isVisible} onHide={store.editAddressModal.hide}>
        <Modal.Header>
          <Modal.Title as="h5">Редактировать адрес</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserAddressEditForm />
        </Modal.Body>
        <Modal.Footer>
          <SaveButton>Сохранить</SaveButton>
          <Button variant="light" onClick={store.editAddressModal.hide}>
            Отменить
          </Button>
        </Modal.Footer>
      </Modal>
    </Formik>
  );
});
